import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface LogoutEvent {
  sessionExpired: boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthEventsService {
  private _logout$ = new Subject<LogoutEvent>();
  readonly logout$ = this._logout$.asObservable();

  requestLogout(sessionExpired: boolean) {
    this._logout$.next({ sessionExpired });
  }
}
